export const exportCashFlowApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/cashflows/export${queryString ? `?${queryString}` : ""}`
}
export const exportReceivableCashFlowApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `/cashflows/receivables/export${queryString ? `?${queryString}` : ""}`
}


// https://qa.lease-revamp.api.sparta.aero/lm/cashflows/export?year=2025&file_type=pdf&scope=contract&lease_slug=7590a602